var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaySolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1989_5448",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 38,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 36.6673C29.2047 36.6673 36.6663 29.2057 36.6663 20.0007C36.6663 10.7957 29.2047 3.33398 19.9997 3.33398C10.7947 3.33398 3.33301 10.7957 3.33301 20.0007C3.33301 29.2057 10.7947 36.6673 19.9997 36.6673Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 20.0018V14.2285L21.6665 17.1152L26.6665 20.0018L21.6665 22.8885L16.6665 25.7752V20.0018Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3.33333,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1989_5448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0V0Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaySolid);
export default __webpack_public_path__ + "static/media/play-solid.f11c28614160b5038e236c924b9cef76.svg";
export { ForwardRef as ReactComponent };